import React, { useEffect, useRef } from 'react';

import { StyledSelect, StyledOptions, StyledOption, StyledSelected } from './dropDown.style';
import { ChangeLangSvg, ChevronDownWhite, ChevronDownRed } from '../../icons';
import InputField from '../inputField';

const DropDown = ({
  options,
  placeholder = 'Select',
  selectedOption,
  defaultValue = null,
  label = '',
  notRequireLabel,
  width = '100%',
  isRed = false,
  isDropDownNotClickable = false,
  isIcon = true,
  isNotRequireDropDown,
}) => {
  const [selected, setSelected] = React.useState(defaultValue);
  const [isOptionsVisible, setIsOptionsVisible] = React.useState(false);

  const dropdownRef = useRef(null);

  useEffect(() => {
    setSelected(defaultValue);
  }, [defaultValue]);

  useEffect(() => {
    // Add event listener to close dropdown when clicking outside
    const handleOutsideClick = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOptionsVisible(false);
      }
    };

    document.addEventListener('click', handleOutsideClick);

    return () => {
      document.removeEventListener('click', handleOutsideClick);
    };
  }, []);

  return (
    <StyledSelect notRequireLabel={notRequireLabel} ref={dropdownRef}>
      <StyledSelected
        selected={selected}
        notRequireLabel={notRequireLabel}
        customWidth={width}
        isRed={isRed}
        isDropDownNotClickable={isDropDownNotClickable}
      >
        <div onClick={isNotRequireDropDown ? null : () => setIsOptionsVisible(!isOptionsVisible)}>
          {selected !== null ? (
            <>
              {!notRequireLabel && (
                <span
                  style={{
                    position: 'absolute',
                    left: '12px',
                    top: '-12px',
                    fontSize: '14px',
                    zIndex: '1',
                    maxWidth: '170px',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    color: '#fff',
                  }}
                >
                  {label}
                </span>
              )}
              {notRequireLabel ? (
                <>
                  <span
                    data-type="text"
                    style={{
                      display: 'flex',
                      gap: '10px',
                      justifyContent: 'center',
                      alignContent: 'center',
                      color: '#fff',
                    }}
                  >
                    <ChangeLangSvg style={{ width: '20px', height: '20px', color: '#fff' }} />
                    {selected.toString()}
                  </span>
                  <span style={{ position: 'absolute', right: '15px', top: '8px' }}>
                    <ChevronDownWhite />
                  </span>
                </>
              ) : (
                <>
                  {isRed ? (
                    <span data-type="text" style={{ color: '##7aeaa7;' }}>
                      {selected.toString()}
                    </span>
                  ) : (
                    <span
                      data-type="text"
                      style={{ color: isDropDownNotClickable ? '#e8e8eb' : '#fff' }}
                    >
                      {selected.toString()}
                    </span>
                  )}
                  <span style={{ position: 'absolute', right: '15px', top: '8px' }}>
                    {isRed ? <ChevronDownRed /> : <ChevronDownWhite />}
                  </span>
                </>
              )}
            </>
          ) : (
            <>
              {notRequireLabel ? (
                <span
                  style={{
                    position: 'absolute',
                    left: '12px',
                    top: '10px',
                    fontSize: '14px',
                    zIndex: '10',
                    display: 'flex',
                    gap: '10px',
                    color: '#fff',
                  }}
                >
                  {isIcon && <ChangeLangSvg style={{ width: '20px', height: '20px' }} />} {label}
                </span>
              ) : (
                <span
                  style={{
                    position: 'absolute',
                    left: '12px',
                    top: '-12px',
                    fontSize: '14px',
                    zIndex: '1',
                    maxWidth: '160px',
                    whiteSpace: 'nowrap',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    color: '#fff',
                  }}
                >
                  {label}
                </span>
              )}
              <InputField
                type="text"
                Name={notRequireLabel ? null : placeholder}
                onClick={() => setIsOptionsVisible(!isOptionsVisible)}
                disabled
                isNotAllow={true}
              />{' '}
              <span style={{ position: 'absolute', right: '15px' }}>
                <ChevronDownWhite />
              </span>
            </>
          )}
        </div>
      </StyledSelected>
      {isOptionsVisible && !isDropDownNotClickable && (
        <StyledOptions
          onClick={() => setIsOptionsVisible(!isOptionsVisible)}
          className="hide-scroll-bar"
        >
          {options.map((option) => (
            <StyledOption
              key={option.value}
              title={option.value}
              value={option.value}
              onClick={() => {
                setSelected(option.label);
                selectedOption(option);
              }}
            >
              {notRequireLabel ? (
                <span style={{ display: 'flex', gap: '10px' }}>
                  {option.icon && option.icon}
                  {option.value === option.label
                    ? option.value.toString()
                    : option.label.toString()}
                </span>
              ) : (
                <span>
                  {option.value === option.label
                    ? option.value.toString()
                    : option.label.toString()}
                </span>
              )}
            </StyledOption>
          ))}
        </StyledOptions>
      )}
    </StyledSelect>
  );
};

export default DropDown;
